export default __webpack_public_path__ + "static/media/F0004.df638dc9.png";